<template>
  <div class="logo-name-wrapper">
    <img :src="logoUrl" class="logo" alt="logo app" />
    <div class="logo-name">
      <span class="logo-name__name">{{ $t("menu.logo.texto_1") }}<br />{{ $t("menu.logo.texto_2") }}</span>
    </div>
    <div class="menu-responsive-btn-container">
      <button type="button" class="menu-responsive-btn btn"><i class="fa-solid fa-bars"></i></button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useLogoStore } from "@/composables/useLogoStore";

const { logoUrl } = useLogoStore();
</script>

<style scoped>
.logo-name-wrapper {
  position: relative;
  margin-bottom: 30px;
  display: flex;

  .logo {
    width: 60px;
    height: 60px;
    object-fit: contain;
  }

  .logo-name {
    display: flex;
    align-items: center;
    transition: opacity 0.5s ease;
  }

  .logo-name__name {
    margin-left: 0.9rem;
    white-space: nowrap;
  }
}

@media (max-width: 992px) {
  .logo-name-wrapper {
    margin-bottom: 0;
  }
}
</style>
